import { Info } from "../alert";
import { Link } from "../link";

export const SnowflakePasswordDeprecation = () => (
  <Info>
    Snowflake is{" "}
    <Link
      variant="inline"
      href="https://www.snowflake.com/en/blog/blocking-single-factor-password-authentification/"
    >
      deprecating password authentication
    </Link>{" "}
    in favor of RSA key pair authentication or multi-factor authentication.
    Hightouch connections configured with password authentication continue to
    work only if Snowflake permits it. For details, see{" "}
    <Link
      variant="inline"
      href="https://docs.snowflake.com/en/user-guide/security-mfa-rollout"
    >
      Snowflake's MFA rollout guide
    </Link>
    . Check your Snowflake account for the rollout timeline.
  </Info>
);
